import { FunctionComponent } from 'react';
import type { DefaultOptionProps } from 'vopay';
import { useTranslation } from 'react-i18next';
import * as vp from 'vopay';

const { Box, PulloverSelect } = vp;

export type ActivityTabType =
  | 'transactionHistory'
  | 'eLinxHistory'
  | 'bankVerifyHistory'
  | 'scheduledTransactions'
  | 'scheduledClientAccountTransfers';

type ActivityTypeProps = {
  activityTypeOptions: DefaultOptionProps[];
  currentType: string;
  handleCurrentType: (val: ActivityTabType) => void;
};

const ActivityType: FunctionComponent<ActivityTypeProps> = ({
  activityTypeOptions,
  currentType,
  handleCurrentType,
}) => {
  const { t } = useTranslation('translations', { keyPrefix: 'Shared.Contacts.Activity' });

  const handleCurrentTypeChange = (value: string) => {
    const activityTabType: ActivityTabType = value as ActivityTabType;
    handleCurrentType(activityTabType);
  };

  return (
    <Box ai="center" gap="sm">
      <Box width="100px">{t('activityType', { defaultValue: 'Activity Type' })}</Box>
      <Box width="300px">
        <PulloverSelect name="activityType" value={currentType} onChange={handleCurrentTypeChange}>
          {activityTypeOptions.map(({ value, label }) => (
            <PulloverSelect.Option key={value} value={value || ''}>
              {label}
            </PulloverSelect.Option>
          ))}
        </PulloverSelect>
      </Box>
    </Box>
  );
};
export default ActivityType;
